module.exports = __webpack_public_path__ + "img/shenfenzhengfanmian.1a533c02.png";